<template src="./login.html" ></template>
<style src="./login.less" lang="less"></style>
<script>
import AuthUser from "@/services/api/authUser";
import Nazgul from "@/services/nazgul";
import subDomain from "@/services/api/subDomains";
import HOME_MAP from "@/services/homeMap";

export default {
  data() {
    return {
      email: "",
      password: "",
      valid: false,
      loading: false,
      error: "",
      required: [v => !!v || "This is required"],
      company: {}
    };
  },
  created() {
    subDomain().then(company => {
      this.company = company;
    });
  },
  methods: {
    submit(e) {
      e.preventDefault();
      if (this.email && this.password) {
        this.loading = true;
        Nazgul.report("login_attempt");
        AuthUser.login({ email: this.email, password: this.password })
          .then((user) => {
            Nazgul.report("login");
            if (this.$route.query.next) {
              this.$router.push(this.$route.query.next);
            } else {
              this.$router.push(HOME_MAP[user.profile.home]);
            }
            this.$emit("loggedIn");
          })
          .catch(e => {
            let status = e.status;
            Nazgul.report("login_failure");
            if (!status) {
              this.error = "This account has been deactivated. Please contact your admin to re-activate."
            }
            else if (status < 500) {
              this.error = "Bad username or password";
            } else {
              this.error =
                "Server error. Our staff has been notified. Please try again later";
            }
          })
          .then(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
